import React from 'react'

const Footer = () => {
    return (
        <div className="py-4 text-center text-xs text-white/60 border-t border-white/10 mt-8">
            © {new Date().getFullYear()} Phospec Industries Inc. — Simulcast
        </div>
    );
}

export default Footer;
